<template>
  <div class="container-empty animate__animated animate__backInLeft">
    <img src="../../../assets/icons/empty-ped.svg" alt="">
    <div class="message-box">
      <h1 class="message-empty">
        {{ message }}
      </h1>
      <h2 class="subtitle-empty">
        {{ subtitle }}
      </h2>
    </div>
  </div>
</template>

<script>
export default {
	props: {
		message: {
			type: String,
			default: 'Ops! Nenhum item encontrado.',
		},
		subtitle: {
			type: String,
			default: 'Verifique os filtros e tente novamente!',
		},
	},
};
</script>

<style scoped lang="scss">
.container-empty {
  width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.container-empty img {
  width: 30%;
}
.message-empty {
  font-size: 14px;
  font-weight: bold;
  color: $empty-color;
  margin-bottom: 5px;
}
.subtitle-empty {
  font-size: 12px;
  font-weight: bold;
  color: $empty-color;
}
.message-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
